import { useState, useEffect } from 'react';
import { StoreDetailPage } from './store/StoreDetailPage';
import { DesktopStoreDetailPage } from './desktop/DesktopStoreDetailPage';

export function ResponsiveStoreDetailPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <StoreDetailPage /> : <DesktopStoreDetailPage />;
}